export const WizardDrawerWrapper = ({ hasDrawer, wrapper, children }) => (hasDrawer ? wrapper(children) : children);
WizardDrawerWrapper.displayName = 'WizardDrawerWrapper';
//# sourceMappingURL=WizardDrawerWrapper.js.map